import React, { useCallback, useState } from "react";
import { useCookies } from "react-cookie";
import { useLocation } from "react-router";
import config from "constants/config";

function useCookiesPolicy(isShop, shopName) {

    const [ updated, setUpdated ] = useState(false);
    const [ cookies, setCookie ] = useCookies(['paylixecommerce-cookies', `shop-cookies-${shopName}`]);
    const location = useLocation();

    const isEU = config.EU_LIST.includes(cookies['ipcountry']);
    const isChina = cookies['ipcountry'] === 'CN';

    let storage =
        cookies[isShop ? `shop-cookies-${shopName}` : "paylixecommerce-cookies"] ?
        cookies[isShop ? `shop-cookies-${shopName}` : "paylixecommerce-cookies"].split(",") :
            cookies[isShop ? `shop-cookies-${shopName}` : "paylixecommerce-cookies"];

    if(!isEU) {
        storage = ['strictly', 'experience', 'measurement', 'targeting'];
    }

    const setCookies = useCallback((data, name, shopName) => {

        const isStaging = window.location.host.includes('paylix.gg');
        const isRealStaging = window.location.host.includes('paylixecommerce-staging.io');
        const isWalletStaging = window.location.host.includes('paylixecommerce-crispy.io');
        const isProduction = window.location.host.includes('paylix.gg');

        let options = {
            path: "/",
            expires: new Date(new Date().getFullYear() + 1, 1, 1, 1, 1, 1, 0),
            sameSite: 'lax',
            secure: false
        }

        let domain = "local-test-paylixecommerce.com";

        if(isStaging) {
            domain = "paylix.gg";
            options.secure = true;
        } else if(isProduction) {
            domain = "paylix.gg";
            options.secure = true;
        } else if(isRealStaging) {
            domain = "paylixecommerce-staging.io";
            options.secure = true;
        } else if(isWalletStaging) {
            domain = "paylixecommerce-crispy.io";
            options.secure = true;
        }

        let sub = isShop ?
            ['.embed', '.checkout', `.${shopName}`, '']
            :
            ['.auth', '.oauth', '.dashboard', '.developers', '.customer-portal', '.embed', '.admin', '.builder', '.checkout', `.${isShop}`, ''];

        sub.map((v) => {
            setCookie(name, data, {
                domain: v ? `${v}.${domain}` : domain,
                ...options
            });
        });

        setCookie(name, data, {
            domain: location.host,
            ...options
        });

        setUpdated(!updated)

    }, [location, isShop, shopName, updated]);

    let allowGoogleTag = false;
    let allowTrustPilot = false;
    let allowIntercom = false;
    let allowCrisp = false;
    let allowHelpSpace = false;

    if(storage && storage.length) {
        if(storage.includes("targeting")) {
            allowGoogleTag = true;
        }
        if(storage.includes("measurement") || storage.includes("experience")) {
            allowTrustPilot = false;
        }
        if(storage.includes("experience")) {
            allowIntercom = true;
            allowCrisp = true;
            allowHelpSpace = true;
        }
    }

    if(!isEU) {
        allowGoogleTag = true;
        allowTrustPilot = true;
        allowIntercom = true;
        allowCrisp = true;
        allowHelpSpace = true;
    }

    if(isChina) {
        allowGoogleTag = false;
    }

    return {
        setCookies,
        cookies: storage,
        allowGoogleTag,
        allowTrustPilot,
        allowIntercom,
        allowCrisp,
        allowHelpSpace
    }
}

export default useCookiesPolicy;
